import React, { Component } from 'react'
import Page from './page'
import './trailer.css'

class Trailer extends Component {
  constructor (props) {
    super(props)
    this.player = null
    this.onPlayerReady = this.onPlayerReady.bind(this)
    window['onYouTubeIframeAPIReady'] = this.onYouTubeIframeAPIReady.bind(this)
  }

  componentDidMount () {
    if (window.YT && window.YT.loaded === 1) {
      this.onYouTubeIframeAPIReady()
    } else {
      let script = document.createElement('script')
      script.src = 'https://www.youtube.com/iframe_api'
      script.async = true
      script.defer = true
      document.body.appendChild(script)
    }
  }

  onYouTubeIframeAPIReady () {
    this.player = new window.YT.Player('player', {
      height: 1920,
      width: 1080,
      events: {
        onReady: this.onPlayerReady
      },
      playerVars: {
        autoplay: 1,
        color: 'white',
        origin: 'https://digtwograves.com',
        rel: 0,
        showinfo: 0,
      },
      videoId: 'vO2JDQ9FPlM'
    })
  }

  onPlayerReady ({ target }) {
    this.player.setPlaybackQuality('hd1080')
  }

  render () {
    return (
      <Page>
        <div className="trailer">
          <div className="video-wrapper">
            <div className="video">
              <div id="player"></div>
            </div>
          </div>
        </div>
      </Page>
    )
  }
}

export default Trailer



// WEBPACK FOOTER //
// ./src/components/trailer.js